const utils = require('frontend-controller/lib/utils')

module.exports = {
    model: {
        projectMeta: {}, // @see MARK: CUSTOMER_PROJECT_META_LOADER
    },

    methods: {

        // which properties is a customer allowed to change?
        onProjectMetaChanged(meta, nextMeta){
            if(
                this.config.isReady
                &&
                (!meta.hash || meta.hash !== nextMeta.hash)
            ){
                this.refresh(false)
            }
        },

        // which properties is a customer allowed to change?
        onBeforeRender(){
            if(utils.isEmpty(this.model.projectMeta)){
                this.locate('< templates_customers_projectTerms_controller', controller => {
                    this.model.projectMeta = {
                        ...(controller.model.projectMeta || {})
                    }
                })
            }
        },
    },

    hooks: {
        // which properties is a customer allowed to change?
        projectMetaChanged($element, options){
            const meta = { ...(this.model.projectMeta || {}) }
            const nextMeta = this.model.projectMeta = (options || {}).projectMeta || {}
            this.onProjectMetaChanged(meta, nextMeta)
        },
    },
}